import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon, FileTextIcon, ZapIcon, LayersIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
const benefits = ['Menos tensión', 'Más claridad', 'Mejores límites', 'Más tranquilidad'];
export function HeroSection() {
  return <section className="relative w-full bg-hero overflow-hidden pt-10 md:pt-16 pb-12 px-4" data-id="element-103" data-mp="28uo7mah80f2m">
      <div className="max-w-4xl mx-auto text-center" data-id="element-104" data-mp="2wl0gpoo7chus">
        {/* Kicker */}
        <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-rose font-bold tracking-[0.18em] text-xs md:text-sm mb-7 uppercase" data-id="element-105" data-mp="30lkdgr4v5jge">
          ⭐ Aula Mater ⭐
        </motion.div>

        {/* Title */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="font-serif font-bold text-4xl sm:text-5xl md:text-6xl lg:text-[5rem] leading-[1.02] text-ink mb-5 uppercase tracking-tight" data-id="element-106" data-mp="3kacteyiqn81u">
          Kit Antiestrés para el Trabajo
        </motion.h1>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-ink-soft text-base md:text-lg mt-5 max-w-2xl mx-auto leading-relaxed" data-id="element-107" data-mp="2z26ix4mrp74c">
          Bajá la tensión del día laboral sin esperar a estar completamente
          agotado.
        </motion.p>

        {/* Italic rose accent */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.35
      }} className="font-serif-italic text-rose text-lg md:text-2xl mt-5" data-id="element-108" data-mp="18smvnvnfbr3y">
          Respiración · Límites · Conversaciones · Ambiente laboral
        </motion.div>

        {/* Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="relative max-w-2xl mx-auto mt-10 md:mt-14" data-id="element-109" data-mp="3mqrgr2yio0fq">
          <div className="absolute inset-8 bg-rose/15 blur-3xl rounded-full" data-id="element-110" data-mp="abz15k54xmf5" />
          <div className="absolute inset-8 bg-gold/10 blur-3xl rounded-full translate-x-10" data-id="element-111" data-mp="edket7phu4qe" />
          <img src="https://cdn.magicpatterns.com/uploads/np9rqYS3TNSS68Zdjz2TLc/imagen_principal.png" alt="Kit Antiestrés para el Trabajo — 4 materiales digitales" className="relative z-10 w-full h-auto rounded-2xl" data-id="element-112" data-mp="jc449i3apyni" />
        </motion.div>

        {/* Trust pills */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.55
      }} className="flex flex-wrap items-center justify-center gap-2.5 mt-10" data-id="element-113" data-mp="1ut86x1m56dvy">
          {[{
          icon: LayersIcon,
          text: '4 materiales + 2 premium'
        }, {
          icon: FileTextIcon,
          text: '+60 páginas prácticas'
        }, {
          icon: FileTextIcon,
          text: '100% PDF'
        }, {
          icon: ZapIcon,
          text: 'Acceso inmediato'
        }].map((p, i) => <div key={i} className="inline-flex items-center gap-2 bg-white border border-line text-ink text-sm font-medium px-4 py-2 rounded-full shadow-sm" data-id="element-114" data-mp="2l2e7txdlp5j2" data-mpi={i}>
              <p.icon className="w-4 h-4 text-rose" data-id="element-115" data-mp="2c2r8ri8cgbt6" />
              {p.text}
            </div>)}
        </motion.div>

        {/* Benefits */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.7
      }} className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mt-6 max-w-2xl mx-auto" data-id="element-116" data-mp="2h2x356600cey">
          {benefits.map((b, i) => <span key={i} className="inline-flex items-center gap-1.5 text-sm text-ink-soft" data-id="element-117" data-mp="2zywldp96c1lc" data-mpi={i}>
              <CheckIcon className="w-4 h-4 text-rose" strokeWidth={3} data-id="element-118" data-mp="3no7npb66a41l" />
              {b}
            </span>)}
        </motion.div>

        {/* CTA */}
        <motion.a href="#oferta" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} whileHover={{
        y: -2
      }} className="inline-flex items-center justify-center gap-2 bg-rose hover:bg-rose-deep text-white font-bold text-base md:text-lg px-12 py-5 rounded-full shadow-xl shadow-rose/30 mt-8 transition-all w-full sm:w-auto max-w-md" data-id="element-119" data-mp="5olkqmu2cnb4">
          <ArrowRightIcon className="w-5 h-5" data-id="element-120" data-mp="3suw3gn8ussq4" />
          QUIERO ACCEDER AL KIT
        </motion.a>

        {/* Trust row */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.9
      }} className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mt-5 text-xs md:text-sm text-muted" data-id="element-121" data-mp="3nui4dup8ct48">
          <span className="flex items-center gap-1.5" data-id="element-122" data-mp="1b5gy5zzkn5f1">
            <LockIcon className="w-4 h-4 text-rose" data-id="element-123" data-mp="1f6kcgi1z0te5" /> Pago seguro
          </span>
          <span className="text-rose/30" data-id="element-124" data-mp="1k6ojlhgzobrp">|</span>
          <span className="flex items-center gap-1.5" data-id="element-125" data-mp="1k6y810mdyava">
            <ZapIcon className="w-4 h-4 text-rose" data-id="element-126" data-mp="1p61fsstr2v6y" /> Acceso en 5 min
          </span>
          <span className="text-rose/30" data-id="element-127" data-mp="rhr8pzf3xh8z">|</span>
          <span className="flex items-center gap-1.5" data-id="element-128" data-mp="rj2hkdnetf6y">
            <ShieldCheckIcon className="w-4 h-4 text-rose" data-id="element-129" data-mp="wgko5xdyfibs" /> Garantía 7 días
          </span>
          <span className="text-rose/30" data-id="element-130" data-mp="11g73qdh99anr">|</span>
          <span className="flex items-center gap-1.5" data-id="element-131" data-mp="11ech8uqc5ahk">
            <CreditCardIcon className="w-4 h-4 text-rose" data-id="element-132" data-mp="166dryc7uut5h" /> Mercado Pago
          </span>
        </motion.div>
      </div>
    </section>;
}